import { clsx } from 'clsx';
import { StoneSkeleton } from '@/components/media/StoneSkeleton';

/** Same footprint as `ProductCard`, so the page does not jump when real cards replace it. */
export function ProductCardSkeleton({ className }: { className?: string }) {
  return (
    <div className={clsx('product-card product-card--skeleton', className)} aria-hidden="true">
      <StoneSkeleton className="product-card__media" />
      <div className="product-card__body">
        <span className="skeleton-line" style={{ width: '32%' }} />
        <span className="skeleton-line skeleton-line--title" style={{ width: '74%' }} />
        <span className="skeleton-line" style={{ width: '58%' }} />
        <span className="skeleton-line skeleton-line--price" style={{ width: '40%' }} />
        <span className="skeleton-line" style={{ width: '96%' }} />
        <span className="skeleton-line" style={{ width: '70%' }} />
        <div className="product-card__actions">
          <span className="skeleton-pill" />
          <span className="skeleton-pill" />
          <span className="skeleton-pill skeleton-pill--round" />
        </div>
      </div>
    </div>
  );
}
